import { render, staticRenderFns } from "./addShareholderDividends.vue?vue&type=template&id=afa9f64c&scoped=true&"
import script from "./addShareholderDividends.vue?vue&type=script&lang=js&"
export * from "./addShareholderDividends.vue?vue&type=script&lang=js&"
import style0 from "./addShareholderDividends.vue?vue&type=style&index=0&id=afa9f64c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa9f64c",
  null
  
)

export default component.exports